import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBubble2"><Path d="M19.502 3C20.8827 3 22.002 4.11929 22.002 5.5V16.5C22.002 17.8807 20.8827 19 19.502 19H12.1304L7.24291 21.6881C7.08801 21.7733 6.89964 21.7704 6.74747 21.6804C6.5953 21.5904 6.50195 21.4268 6.50195 21.25V19H4.50195C3.12124 19 2.00195 17.8807 2.00195 16.5V5.5C2.00195 4.11929 3.12124 3 4.50195 3H19.502Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble2;
